<template>
<div>
  <div v-if="step === 0" class="double-card-page-container">
    <login-form admin="false"></login-form>
  </div>
  <div v-show="step === 1" class="card-page-container alert">
    <reset-form></reset-form>
  </div>
  <div v-show="step === 2" class="card-page-container"  >
    <div class="mdl-grid">
      <div class="mdl-layout-spacer"></div>
      <div class="mdl-cell fill mdl-shadow--2dp">
        <alert message="login.reset.message.actionResponse"></alert>
      </div>
      <div class="mdl-layout-spacer"></div>
    </div>
  </div>
  <div v-show="step === 3" class="card-page-container">
    <div class="mdl-grid">
      <div class="mdl-layout-spacer"></div>
      <div class="mdl-cell fill mdl-shadow--2dp">
        <alert message="login.message.toomanyattempts" goto="/app"></alert>
      </div>
      <div class="mdl-layout-spacer"></div>
    </div>
  </div>
  <div v-show="step === 4" class="card-page-container"  >
    <div class="mdl-grid">
      <div class="mdl-layout-spacer"></div>
      <div class="mdl-cell fill mdl-shadow--2dp">
        <alert title="register.verify.message.title" message="register.verify.message.text" goto="/app/login"></alert>
      </div>
      <div class="mdl-layout-spacer"></div>
    </div>
  </div>
</div>
</template>

<script>
  var auth = require('api/Auth')
  var api = require('api')
  var local = require('common/store/local')
  var actions = require('common/store/actions')
  module.exports = {
    ready: function () {
      window.componentHandler.upgradeAllRegistered()
      if (location.href.includes('?lang=')) {
        let split = location.href.split('?lang=').pop()
        if (local.get('client.language') !== split) {
          this.changeLanguage(split)
        }
      }
    },
    vuex: {
      actions: actions
    },
    components: {
      loginForm: require('c/forms/LoginForm'),
      resetForm: require('c/forms/ResetForm'),
      alert: require('c/components/Alert')
    },
    methods: {
      onError: function (err) {
        if (err.status === 404) {
          this.$broadcast('reset-validation-fail', err.data.message)
        } else {
          this.$dispatch('show-error', err.data)
        }
      }
    },
    events: {
      'login-valid': function (credentials) {
        var self = this
        this.$dispatch('loading', true)
        auth.login(credentials, function (authData) {
          var goto = local.get('goto')
          if (self.$route.query.redirect) {
            goto = self.$route.query.redirect
          } else if (!goto) {
            goto = '/app/profile' //  /app/message/new' // '/managed'
          }
          self.$dispatch('authenticate', authData, goto)
          self.$dispatch('loading', false)
        }, function (err) {
          if (err.data.message === 'user.error.pending') {
            self.step = 4
          } else if (err.data.message === 'user.error.wrongcredentials') {
            self.$broadcast('credentials-validation-fail', 'user.error.wrongcredentials')
            self.$dispatch('loading', false)
          } else if (err.data.message === 'user.error.wrongcaptcha') {
            self.$broadcast('captcha-validation-fail', 'user.error.wrongcaptcha')
          } else {
            self.$dispatch('show-error', err.data)
          }
          self.$dispatch('loading', false)
        })
      },
      'forgot-password': function () {
        this.step = 1
      },
      'back-to-login': function () {
        this.step = 0
      },
      'reset-request': function (email) {
        var self = this
        api.User.resetRequest({email: email}).then(function (response) {
          self.step = 2
        }, this.onError)
      },
      'alert-done': function () {
        this.step = 0
      }
    },
    data: function () {
      return {
        step: 0
      }
    }
  }
</script>

<style scoped>
  .mdl-button {
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?69c2946a